module.exports = __webpack_public_path__ + "static/landing-08e18cb904f0f3c6dd9e3d4ed72e0eca.jpg";